import React from "react";
import { ASSETS, GURUKULA } from "../../lib/api";
import OrnamentalDivider from "./OrnamentalDivider";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-maroon-900 text-ivory">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                    <div>
                        <div className="flex items-center gap-3">
                            <img
                                src={ASSETS.logo}
                                alt="Gurukula Logo"
                                className="h-14 w-14 rounded-full object-cover ring-1 ring-gold/40"
                            />
                            <div className="font-display text-2xl text-ivory leading-tight">
                                Shri Vishwa Bandhu
                                <span className="block italic text-gold-300 text-lg">
                                    Sangeetha Gurukula
                                </span>
                            </div>
                        </div>
                        <p className="mt-6 font-serif text-ivory/75 leading-relaxed">
                            Where dedication finds its voice and music finds its soul.
                        </p>
                        <p className="text-kannada text-base text-gold-300 mt-3 italic">
                            ನಾದವೇ ದೈವ, ಸಂಗೀತವೇ ಸಾಧನೆ.
                        </p>
                    </div>

                    <div>
                        <div className="eyebrow text-gold-300">Explore</div>
                        <ul className="mt-5 space-y-2 font-serif text-ivory/85">
                            <li><a href="/#about" className="hover:text-gold-300">About</a></li>
                            <li><a href="/#founder" className="hover:text-gold-300">Founder</a></li>
                            <li><a href="/#courses" className="hover:text-gold-300">Courses</a></li>
                            <li><a href="/vision" className="hover:text-gold-300">Our Vision</a></li>
                            <li><a href="/social-service" className="hover:text-gold-300">Social Service</a></li>
                            <li><a href="/vision#donate" className="hover:text-gold-300">Donate</a></li>
                            <li><a href="/#gallery" className="hover:text-gold-300">Legacy</a></li>
                            <li><a href="/#contact" className="hover:text-gold-300">Contact</a></li>
                        </ul>
                    </div>

                    <div>
                        <div className="eyebrow text-gold-300">Contact</div>
                        <div className="mt-5 font-serif text-ivory/85 space-y-3">
                            <a
                                href={`tel:${GURUKULA.phone}`}
                                className="block font-sans font-medium text-3xl lg:text-4xl tabular-nums tracking-[0.1em] text-ivory hover:text-gold-300 transition-colors"
                                data-testid="footer-phone"
                            >
                                {GURUKULA.phone}
                            </a>
                            <a
                                href={GURUKULA.mapUrl}
                                target="_blank"
                                rel="noreferrer noopener"
                                className="block hover:text-gold-300"
                                data-testid="footer-address"
                            >
                                {GURUKULA.address}
                            </a>
                            <a
                                href={GURUKULA.youtubeWatch}
                                target="_blank"
                                rel="noreferrer noopener"
                                className="block hover:text-gold-300"
                            >
                                Watch on YouTube ↗
                            </a>
                        </div>
                    </div>
                </div>

                <OrnamentalDivider className="my-12 opacity-70" />
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-[11px] uppercase tracking-[0.28em] text-ivory/55 font-sans">
                    <span>© {new Date().getFullYear()} Shri Vishwa Bandhu Sangeetha Gurukula</span>
                    <span>Practice Silent. Perform Divine.</span>
                </div>
            </div>
        </footer>
    );
}
